import { clstx } from '@payaca/utilities/cvaMerge';
import React, { ComponentPropsWithoutRef, FC, PropsWithChildren } from 'react';
import FloatingTooltip, {
  IProps as IFloatingTooltipProps,
} from './FloatingTooltip';
import TooltipCore from './TooltipCore';

export type TooltipProps = {
  tooltipContent: React.ReactNode;
  placement?: IFloatingTooltipProps['placement'];
} & Omit<IFloatingTooltipProps, 'arrowClassName' | 'children'> &
  ComponentPropsWithoutRef<'div'>;

const Tooltip: FC<PropsWithChildren<TooltipProps>> = (props) => {
  const {
    placement,
    showArrow,
    enabled,
    tooltipContent,
    className,
    children,
    ...rest
  } = props;

  return (
    <FloatingTooltip
      placement={placement}
      showArrow={showArrow}
      enabled={enabled}
      arrowClassName="fill-gray-900 shadow-sm dark:fill-gray-700"
    >
      <div className={clstx('inline-block', className)} {...rest}>
        {children}
      </div>

      <TooltipCore>{tooltipContent}</TooltipCore>
    </FloatingTooltip>
  );
};

export default Tooltip;
